import { Card, Stack, Typography } from '@mui/material';
import { colors } from '../../shared/styles';
import React from 'react';

interface PropertyCardProps {
  title?: string;
  children: React.ReactNode | React.ReactNode[];
}

/// Property card component, for showing properties of the
/// item. This element should always be in some sort of grid,
/// so no style overrides are exposed.
export default function PropertyCard({ title, children }: PropertyCardProps) {
  return (
    <Stack direction={'column'}>
      {title && (
        <Typography color={colors.darkGray} fontWeight={'bold'}>
          {title}
        </Typography>
      )}
      <Card
        variant='outlined'
        sx={{ marginLeft: 0, paddingLeft: 0, marginRight: 0, paddingRight: 0 }}
      >
        {children}
      </Card>
    </Stack>
  );
}
